import React from 'react'
import { Formik } from 'formik'
import { Button, Form, Spacer, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Input } from 'src/components/ConnectedForm'
import { useCreatePage } from 'src/graphql/hooks'

const PageCreate = ({ onCancelButtonClick, onCreate, targetId, targetType }) => {
   const { createPage } = useCreatePage()
   const entityName = targetType === 'initiative' ? 'Tab' : 'Page'

   const handleCreatePage = async (values, actions) => {
      const result = await createPage({
         ...values,
         initiativeId: targetType === 'initiative' ? targetId : undefined
      })

      actions.setSubmitting(false)
      actions.resetForm()

      if (onCreate) {
         onCreate(result.data.createPage)
      }
   }

   return (
      <View>
         <View
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            padding="18px"
            borderBottom="1px solid #eee">
            <Text size="3" weight="medium">
               {`Create New ${entityName}`}
            </Text>
         </View>
         <Formik
            initialValues={{ title: '' }}
            onSubmit={handleCreatePage}
            render={({ handleSubmit, isSubmitting }) => (
               <Form
                  elementAppearance="plain"
                  elementBackgroundColor="#eee"
                  onSubmit={handleSubmit}>
                  <View padding="18px">
                     <View>
                        <Text size="2" color="#444">
                           {`Please enter a title for this new ${entityName}`}
                        </Text>
                        <Spacer size="2" />
                        <Input name="title" size="lg" placeholder={`${entityName} Title`} />
                        {/*
                        TODO: Add this when content navigation options are available
                        <Spacer size="2" />
                        <Checkbox
                           highlightColor="#f7b77c"
                           label="Create link to this page in main site navigation"
                           defaultChecked
                        /> */}
                     </View>
                     <Spacer size="3" />
                     <View display="flex" justifyContent="flex-end">
                        <Button
                           width="50%"
                           onClick={onCancelButtonClick}
                           name="Cancel"
                           color="#fff"
                           textColor="#666"
                        />
                        <Button
                           width="50%"
                           type="submit"
                           name="Create"
                           color="#f7b77c"
                           textColor="#111"
                           mode={isSubmitting ? 'loading' : 'normal'}
                        />
                     </View>
                  </View>
               </Form>
            )}
         />
      </View>
   )
}

PageCreate.propTypes = {
   onCancelButtonClick: PropTypes.func,
   onCreate: PropTypes.func,
   targetId: PropTypes.string,
   targetType: PropTypes.oneOf(['organization', 'initiative']).isRequired
}

PageCreate.defaultProps = {
   onCancelButtonClick: undefined,
   onCreate: undefined,
   targetId: undefined
}

export default PageCreate
